import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { register } from "./core/index.mjs";
import useEnhancedEffect from "./use/useEnhancedEffect.mjs";
var createSource = function createSource() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ui-kit-';
  return {
    value: 1,
    prefix: prefix
  };
};
export var useUID = function useUID(prefix) {
  var _context$prefix;
  var context = register.get('uid-context', createSource(prefix));
  var _ref = React.useId ? [React.useId()] : React.useState(context.value++),
    _ref2 = _slicedToArray(_ref, 1),
    uid = _ref2[0];
  var trimmedUid = String(uid).startsWith(':') && String(uid).endsWith(':') ? String(uid).slice(1, -1) : uid;
  useEnhancedEffect(function () {
    register.set('uid-context', context);
  }, [trimmedUid]);
  return ((_context$prefix = context.prefix) !== null && _context$prefix !== void 0 ? _context$prefix : '') + trimmedUid;
};
export default (function (prefix) {
  return function (props) {
    var uid = useUID(prefix);
    return _objectSpread({
      uid: uid
    }, props);
  };
});
//# sourceMappingURL=uniqueID.mjs.map